// ======================================================================
// FILE:
// src/modules/wms/reports/components/SummaryCards.jsx
//
// MODULE:
// Work Management System (WMS)
//
// FEATURE:
// Compact Modern KPI Cards
// ======================================================================

import React from "react";

export default function SummaryCards({

    summary = {},

}) {

    const cards = [

        {
            title: "Open Work",
            value: summary.total_open_work || 0,
            color: "#2563EB",
            icon: "📋",
        },

        {
            title: "Critical",
            value: summary.critical || 0,
            color: "#DC2626",
            icon: "🔴",
        },

        {
            title: "High",
            value: summary.high || 0,
            color: "#EA580C",
            icon: "🟠",
        },

        {
            title: "Overdue",
            value: summary.overdue || 0,
            color: "#B91C1C",
            icon: "⏰",
        },

        {
            title: "Due Today",
            value: summary.due_today || 0,
            color: "#D97706",
            icon: "📅",
        },

        {
            title: "Pending Approval",
            value: summary.pending_approval || 0,
            color: "#7C3AED",
            icon: "✅",
        },

        {
            title: "Within SLA",
            value: summary.within_sla || 0,
            color: "#059669",
            icon: "🟢",
        },

        {
            title: "Breached SLA",
            value: summary.breached_sla || 0,
            color: "#DC2626",
            icon: "⚠️",
        },

        {
            title: "Average Completion",
            value: `${summary.average_completion || 0}%`,
            color: "#0891B2",
            icon: "📈",
        },

    ];

    return (

        <div

            style={{

                display: "grid",

                gridTemplateColumns:
                    "repeat(auto-fit, minmax(220px, 1fr))",

                gap: 12,

                marginBottom: 18,

            }}

        >

            {

                cards.map((card) => (

                    <SummaryCard

                        key={card.title}

                        {...card}

                    />

                ))

            }

        </div>

    );

}

// ======================================================================
// KPI CARD
// ======================================================================

function SummaryCard({

    title,

    value,

    color,

    icon,

}) {

    return (

        <div

            style={{

                background: "#fff",

                borderRadius: 12,

                borderLeft: `5px solid ${color}`,

                padding: "12px 16px",

                height: 78,

                display: "flex",

                alignItems: "center",

                justifyContent: "space-between",

                boxShadow:
                    "0 2px 8px rgba(0,0,0,.08)",

                transition: "all .2s ease",

                cursor: "default",

            }}

            onMouseEnter={(e) => {

                e.currentTarget.style.transform =
                    "translateY(-2px)";

                e.currentTarget.style.boxShadow =
                    "0 6px 16px rgba(0,0,0,.12)";

            }}

            onMouseLeave={(e) => {

                e.currentTarget.style.transform =
                    "translateY(0px)";

                e.currentTarget.style.boxShadow =
                    "0 2px 8px rgba(0,0,0,.08)";

            }}

        >

            <div

                style={{

                    display: "flex",

                    alignItems: "center",

                    gap: 12,

                }}

            >

                <div

                    style={{

                        fontSize: 26,

                    }}

                >

                    {icon}

                </div>

                <div>

                    <div

                        style={{

                            fontSize: 12,

                            color: "#6B7280",

                            fontWeight: 600,

                            marginBottom: 3,

                        }}

                    >

                        {title}

                    </div>

                    <div

                        style={{

                            fontSize: 28,

                            fontWeight: 700,

                            color: "#111827",

                            lineHeight: 1,

                        }}

                    >

                        {value}

                    </div>

                </div>

            </div>

        </div>

    );

}